import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  insertContract,
  getEmployeCin,
  getEmployeesNames,
  getPostNames,
  getContractTypeNames,
} from "../../../../services/RHService/ContractService";
import moment from "moment";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
const AddContract = () => {
  const [postNames, setPostNames] = useState([]);
  const [contracttypeNames, setContracttypeNames] = useState([]);
  const [employeesNames, setEmployeesNames] = useState([]);
  const [postError, setPostError] = useState("");
  const [employeeError, setEmployeeError] = useState("");
  const [contracttypeError, setContracttypeError] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [selectedEmployeeEmail, setSelectedEmployeeEmail] = useState("");

  useEffect(() => {
        getContractTypeNames(getCurrentUserId()).then((contractTypeNames)=>{
          setContracttypeNames(contractTypeNames.data?.success);
        }).catch((error)=>{
          console.error(error);
        })
        getPostNames(getCurrentUserId()).then((postNames)=>{
          setPostNames(postNames.data.success); 
        }).catch((error)=>{
          console.error(error);
        })
        getEmployeesNames(getCurrentUserId()).then((employeesNames=>{
          setEmployeesNames(employeesNames.data?.success); 

        })).catch((error)=>{
          console.error(error);
        }) 
  }, []);

  //Define the state variables for the form data
  const [formData, setFormData] = useState({});
  //Define an event handler function to update the state variables when the user inputs data into the form fields
  useEffect(() => {
    setSelectedEmployeeId(formData.idEmployee);
  }, [formData]);

  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    if (name === "typeSalaire") {
      if (value === "BRUT") {
        setFormData({
          ...formData,
          typeSalaire: value,
          montant_brut: "",
        });
      } else {
        setFormData({
          ...formData,
          typeSalaire: value,
          montantNet: "",
        });
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  useEffect(() => {
  
        if (selectedEmployeeId !="" && selectedEmployeeId !=undefined) {
         getEmployeCin(selectedEmployeeId).then((cin)=>{
          setSelectedEmployeeEmail(cin.data?.success);
         })
        } else {
          setSelectedEmployeeEmail("");
        }
     
  }, [selectedEmployeeId, formData.idEmployee]);

  //submit le form
  const handleSubmit = async (event) => {
    event.preventDefault();
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.token?.idUser;

    formData.idUser = userId;
    console.log(formData);
    // return;
    const {
      idEmployee,
      idContractType,
      idPost,
      date_deb,
      date_fin,
      ...otherFormData
    } = formData;

    if (
      !formData.mode_paiement ||
      !formData.nom_diplome ||
      !formData.nivaux_diplome ||
      !formData.nb_jrs_cong
    ) {
      toastr.error("Veuillez renseigner tous les champs.");
      return;
    }

    if (
      (formData.mode_paiement === "chéque" ||
        formData.mode_paiement === "virementBoncaire") &&
      !formData.rib &&
      formData.rib.length !== 10 &&
      isNaN(formData.rib)
    ) {
      toastr.error(
        "Si vous avez choisi le mode de paiement 'chéque' ou 'Virement Bancaire', veuillez renseigner le champ RIB , RIB doit etre 10 chiffres."
      );
      return;
    }

    // if (isNaN(formData.montant_brut)) {
    //   toastr.error(
    //     "Montant brut invalide : veuillez saisir un nombre réel ou un chiffre."
    //   );
    //   return;
    // }

    if (!idEmployee || idEmployee === "") {
      setEmployeeError("Veuillez saisir un employé.");
      return;
    } else {
      setEmployeeError("");
    }

    if (!idContractType) {
      setContracttypeError("Veuillez saisir un type de contrat.");
      return;
    } else {
      setContracttypeError("");
    }

    if (!idPost) {
      setPostError("Veuillez saisir un poste.");
      return;
    } else {
      setPostError("");
    }
    // if (Number.isInteger(Number(formData.nbMoisParAnnee))) {
    //     toastr.error("Veuillez saisir un nombre entier.");
    //     return;
    //   }
    // Convert date format to 'YYYY-MM-DD'
    const formattedFormData = {
      ...otherFormData,
      date_deb: moment(formData.date_deb).format("YYYY-MM-DD"),
      date_fin: moment(formData.date_fin).format("YYYY-MM-DD"),
    };
    // Check if date_deb is before date_fin
    const startDate = moment(formattedFormData.date_deb, "YYYY-MM-DD");
    const endDate = moment(formattedFormData.date_fin, "YYYY-MM-DD");

    if (endDate.isBefore(startDate)) {
      toastr.error("La date de début doit être antérieure à la date de fin.");
      return Promise.reject(
        "La date de début doit être antérieure à la date de fin."
      );
    }
    try {
      const response = await insertContract(formData);
      console.log(response);
      if (response.data && response.data?.status === "success") {
        toastr.success("Contrat ajouter avec succée");
      } else if (response.data && response.data?.status === "error") {
        toastr.error(response.data?.message);
      } else if (response.data && response.data?.status === "error1") {
        toastr.error(response.data?.message);
      } else if (response.data && response.data?.status === "error2") {
        toastr.error(response.data?.message);
      }
    } catch (error) {
      toastr.error(
        "Erreur lors de la vérification du contrat existant ou lors de l'insertion du contrat."
      );
    }
  };

  return (
    <div class="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Ajouter un contrat</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/contractList">Liste des contrats</Link>
                </li>
                <li className="breadcrumb-item active">Ajouter un contrat</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div class="card-header">
                  <h4 class="card-title">Etablir un contrat</h4>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card-body">
                        <div className="row">
                          <label for="exampleSelectBorder">
                            Nom du personnel (qui n'ont pas du contrat){" "}
                          </label>

                          <div className="col-md-6">
                            <div className="form-group">
                              <select
                                className="custom-select form-control-border"
                                name="idEmployee"
                                value={formData.idEmployee}
                                onChange={handleInputChange}
                              >
                                <option value="">
                                  --Choisir un employee--
                                </option>
                                {employeesNames.map((employeesName) => (
                                  <option
                                    key={employeesName.idPersonnel}
                                    value={employeesName.idPersonnel}
                                  >
                                    {employeesName.firstname}{" "}
                                    {employeesName.lastname}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            {selectedEmployeeEmail && (
                              <button
                                type="button"
                                class="btn btn-block btn-default"
                              >
                                {selectedEmployeeEmail}
                              </button>
                            )}
                          </div>
                        </div>

                        {employeeError && (
                          <p style={{ color: "red" }}>{employeeError}</p>
                        )}
                        <div className="form-group">
                          <label>Type de contrat </label>
                          <select
                            className="custom-select form-control-border"
                            name="idContractType"
                            onChange={handleInputChange}
                            value={formData.idContractType}
                          >
                            <option value="typecontrat">
                              --Choisir un type de contrat--
                            </option>
                            {contracttypeNames.map((contracttypeName) => (
                              <option
                                key={contracttypeName.id}
                                value={contracttypeName.id}
                              >
                                {contracttypeName.nomContrat}
                              </option>
                            ))}
                          </select>
                        </div>
                        {contracttypeError && (
                          <p style={{ color: "red" }}>{contracttypeError}</p>
                        )}
                        <div className="form-group">
                          <label>Poste </label>
                          <select
                            className="custom-select form-control-border"
                            name="idPost"
                            onChange={handleInputChange}
                            value={formData.idPost}
                          >
                            <option value="post">--Choisir un post--</option>

                            {postNames.map((postName) => (
                              <option key={postName.id} value={postName.id}>
                                {postName.nomPost}
                              </option>
                            ))}
                          </select>
                        </div>
                        {postError && (
                          <p style={{ color: "red" }}>{postError}</p>
                        )}
                        <div className="form-group">
                          <label>Date Début:</label>
                          <div
                            className="input-group date"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              value={formData.date_deb}
                              name="date_deb"
                              onChange={handleInputChange}
                              min="1900-01-01"
                              max="2100-12-31"
                              className="form-control form-control-border "
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <label>Catégorie </label>
                          <div className="input-group">
                            <input
                              type="number"
                              name="classRevenu"
                              value={formData.classRevenu}
                              onChange={handleInputChange}
                              className="form-control form-control-border"
                              min="0"
                              max="100"
                              step="1"
                              placeholder="Catégorie "
                            />
                          </div>
                          </div>
                          <div className="form-group">
                          <label>Coeffécient SMIG </label>
                          <div className="input-group">
                            <input
                              type="number"
                              name="coefSmig"
                              value={formData.coefSmig}
                              onChange={handleInputChange}
                              className="form-control form-control-border"
                              min="0"
                              max="100"
                              step="0.5"
                              placeholder="Coef SMIG "
                            />
                          </div>
                          </div>
                        <div className="form-group">
                          <label for="exampleSelectBorder">
                            Mode de paiment{" "}
                          </label>

                          <select
                            className="custom-select form-control-border"
                            name="mode_paiement"
                            value={formData.mode_paiement}
                            onChange={handleInputChange}
                          >
                            <option value="">
                              -- Choisissez une option --
                            </option>
                            <option value="ESPECE">Espéce</option>
                            <option value="CHEQUE">Chéque</option>
                            <option value="VIREMENT">
                              Virement
                            </option>
                          </select>
                        </div>
                        {(formData.mode_paiement === "CHEQUE" && (
                          <div className="form-group">
                            <label>RIB</label>

                            <input
                              type="text"
                              name="rib"
                              value={formData.rib}
                              onChange={handleInputChange}
                              className="form-control form-control-border"
                              placeholder="RIB"
                            />
                          </div>
                        )) ||
                          (formData.mode_paiement === "VIREMENT" && (
                            <div>
                              <label className="form-group">
                                <label>RIB </label>
                                <input
                                  type="text"
                                  name="rib"
                                  value={formData.rib}
                                  onChange={handleInputChange}
                                  className="form-control form-control-border"
                                  placeholder="RIB"
                                />
                              </label>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card-body">
                        <div className="form-group">
                          <label>Nom de diplome</label>
                          <input
                            type="text"
                            name="nom_diplome"
                            value={formData.nom_diplome}
                            className="form-control form-control-border"
                            onChange={handleInputChange}
                            placeholder="Nom de diplome"
                          />
                        </div>
                        <div className="form-group">
                          <label>Niveau de diplome</label>
                          <select
                            className="custom-select form-control-border"
                            onChange={handleInputChange}
                            value={formData.nivaux_diplome}
                            name="nivaux_diplome"
                          >
                            <option value="">
                              --Choisir un Niveau de diplome--
                            </option>

                            <option value="Diplôme non validé">
                              Diplôme non validé
                            </option>
                            <option value="Bac Professionnel, BEP, CAP">
                              Bac Professionnel, BEP, CAP
                            </option>
                            <option value="Doctorat, PHD">Doctorat, PHD</option>
                            <option value="Ingénieur">Ingénieur</option>
                            <option value="Licence, Bac + 3">
                              Licence, Bac + 3
                            </option>
                            <option value="Lycée, Niveau Bac">
                              Lycée, Niveau Bac
                            </option>
                            <option value="Bac non validé">
                              Bac non validé
                            </option>
                            <option value="Etudiant">Etudiant</option>
                            <option value="DUT, BTS, Bac + 2">
                              DUT, BTS, Bac + 2
                            </option>
                            <option value="Maîtrise, IEP, IUP, Bac + 4">
                              Maîtrise, IEP, IUP, Bac + 4
                            </option>
                            <option value="DESS, DEA, Master, Bac + 5, Grandes Ecoles">
                              DESS, DEA, Master, Bac + 5, Grandes Ecoles
                            </option>
                          </select>
                        </div>

                        {/* <div className="form-group">
                          <label>Montant Brute mensuel</label>
                          <input
                            type="text"
                            onChange={handleInputChange}
                            className="form-control form-control-border"
                            value={formData.montant_brut}
                            name="montant_brut"
                            placeholder="Montant"
                          />
                        </div> */}
                        <div className="col-md-12 mt-4 mb-4">
                          <div class="icheck-dark d-inline  ">
                            <input
                              type="radio"
                              id="radioPrimary1"
                              onChange={handleInputChange}
                              value="BRUT"
                              name="typeSalaire"
                              checked={formData.typeSalaire === "BRUT"}
                            />
                            <label htmlFor="radioPrimary1">Brut</label>
                          </div>
                          <div class="icheck-dark d-inline mx-5">
                            <input
                              type="radio"
                              id="radioPrimary2"
                              onChange={handleInputChange}
                              value="NET"
                              name="typeSalaire"
                              checked={formData.typeSalaire === "NET"}
                            />
                            <label htmlFor="radioPrimary2">Net</label>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>
                            Montant{" "}
                            {formData.typeSalaire === "BRUT" ? "brut" : "net"}
                          </label>
                          <input
                            type="text"
                            name={`montant${
                              formData.typeSalaire === "BRUT" ? "_brut" : "Net"
                            }`}
                            value={formData.montant}
                            className="form-control form-control-border"
                            onChange={handleInputChange}
                            placeholder={`Montant ${
                              formData.typeSalaire === "BRUT" ? "brut" : "net"
                            }`}
                          />
                        </div>
                        <div className="form-group">
                          <label>Date de fin</label>
                          <div
                            className="input-group date"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              min="1900-01-01"
                              value={formData.date_fin}
                              onChange={handleInputChange}
                              className="form-control form-control-border "
                              name="date_fin"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Nombre initiale de congé </label>
                          <div className="input-group">
                            <input
                              type="number"
                              name="nb_jrs_cong"
                              value={formData.nb_jrs_cong}
                              onChange={handleInputChange}
                              className="form-control form-control-border"
                              min="0"
                              max="100"
                              step="1"
                              placeholder="Nombre initiale de congé "
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Nombre de mois par année </label>
                          <div className="input-group">
                            <input
                              type="number"
                              name="nbMoisParAnnee"
                              value={formData.nbMoisParAnnee}
                              onChange={handleInputChange}
                              className="form-control form-control-border"
                              min="0"
                              max="100"
                              step="1"
                              placeholder="Nombre de mois par année"
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <label>Coefficient des heures supplimentaires </label>
                          <div className="input-group">
                            <input
                              type="number"
                              name="suppHeureCoefficient"
                              value={formData.suppHeureCoefficient}
                              onChange={handleInputChange}
                              className="form-control form-control-border"
                              min="0"
                              max="100"
                              step="any"
                              placeholder="Coefficient des heures supplimentaires"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <button
                      type="submit"
                      className="btn btn-dark col-md-3 float-right"
                      style={{ width: "auto" }}
                    >
                      Etablir
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddContract;
